// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2kIzy","select":"Header_select__1kSb9","clinic":"Header_clinic__CPWbo"};